<!--  -->
<template>
  <section class="study-progress">
    <h1 class="study-title">
      <img
        src="../../../assets/img/learningGuidePage/report-icon1.png"
        alt=""
      /><span>课程学习进度</span>
      <img
        @click="instrucTionsOpen"
        src="../../../assets/img/learningGuidePage/reporttip.png"
        alt=""
      >
    </h1>
    <div class="progress">
      <div><span :style="{ width: newPercent + '%' }"></span></div>
      <b>{{ newPercent }}%</b>
    </div>
    <div class="study-info">
      <div>
        <h3>累计学习</h3>
        <p>
          <span>{{ studyInfo.learnDuration || 0 }}</span>分钟
        </p>
        <img
          class="bgImg"
          src="../../../assets/img/learningGuidePage/reportleft2.png"
          alt=""
        />
      </div>
      <div v-if="studyInfo.classRanking !== -1">
        <h3>班级排名</h3>
        <p>
          第<span>{{ studyInfo.classRanking }}</span>名
        </p>
        <img
          class="bgImg"
          src="../../../assets/img/learningGuidePage/reportright.png"
          alt=""
        />
      </div>
    </div>
    <div class="study-card">
      <template v-if="JSON.stringify(studyInfo)!=='{}'">
        <div>
          <h4>直播课</h4>
          <p>
            <span>{{ studyInfo.finishLiveNumber }}</span>/{{ studyInfo.liveNumber }}
          </p>
        </div>
        <div>
          <h4>录播课</h4>
          <p>
            <span>{{ studyInfo.finishVideoNumber }}</span>/{{ studyInfo.videoNumber }}
          </p>
        </div>
        <div v-if="studyInfo.questionAnswerTimes !== -1">
          <h4>答疑</h4>
          <p>
            <span>{{ studyInfo.questionAnswerTimes }}</span>次
          </p>
        </div>
        <div v-if="studyInfo.daKaTimes !== -1">
          <h4>打卡</h4>
          <p>
            <span>{{ studyInfo.daKaTimes }}</span>次
          </p>
        </div>
        <div v-if="studyInfo.examNum!==-1">
          <h4>考试</h4>
          <p>
            <span>{{ studyInfo.examNum }}</span>次
          </p>
        </div>
        <div v-if="studyInfo.correctNum!==-1">
          <h4>批改</h4>
          <p>
            <span>{{ studyInfo.correctNum }}</span>次
          </p>
        </div>
      </template>
    </div>

    <!-- <div
      class="study-info"
      v-if="studyInfo.classRanking !== -1"
    >
      班级排名第<span>{{ studyInfo.classRanking }}</span>名
    </div>
    <div class="study-info">
      已学习<span>{{ studyInfo.learnDays || 0 }}</span>天，累计学习<span>{{ studyInfo.learnDuration||0 }}</span>分钟
    </div>
    <div
      class="study-card"
      v-if="studyInfo.liveNumber"
    >
      <div>
        完成直播课<span>{{ studyInfo.finishLiveNumber }}/{{ studyInfo.liveNumber }}</span>节
      </div>
      <div v-if="studyInfo.videoNumber">
        完成录播课<span>{{ studyInfo.finishVideoNumber }}/{{ studyInfo.videoNumber }}</span>节
      </div>
      <div v-if="studyInfo.questionAnswerTimes !== -1">
        平台答疑<span>{{ studyInfo.questionAnswerTimes }}</span>次
      </div>
      <div v-if="studyInfo.dakaTimes !== -1">
        打卡<span>{{ studyInfo.dakaTimes }}</span>次
      </div>
    </div> -->
    <InstructionsPop
      v-if="popShow"
      :contentInstructions="contentInstructions"
      @popClose="popClose"
    />
  </section>
</template>

<script>
import InstructionsPop from './instructionsPop.vue';

export default {
  components: {
    InstructionsPop,
  },
  data() {
    return {
      popShow: false,
      // 学习进度说明弹窗
      contentInstructions: [
        '1.课程学习进度=所有已更新视频观看进度的平均值（随课程陆续更新，学习进度可能会减少）。',
        '2.累计学习：课程累计观看时长之和。',
        '3.班级排名：所在班级同科目课程的学习进度排名。',
        '4.课程完成规则：直播课/直播回放或录播课观看时长至少占每节课总时长80%。 离线播放会在下一次联网时自动同步进度。',
        '5.答疑、打卡、考试、批改均为APP平台提交的次数。',
        '6.学习时长：直播、回放、录播的观看时长；重复观看会重复计算时长。',
      ],
    };
  },
  props: {
    studyInfo: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    newPercent() {
      const percent = Math.trunc((this.studyInfo.productLearnProgress || 0) * 100);
      return percent > 100 ? 100 : percent;
    },
  },
  watch: {},
  methods: {
    instrucTionsOpen() {
      this.popShow = true;
    },
    popClose() {
      this.popShow = false;
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.study-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 45px;
  img {
    width: 29px;
    height: 29px;
  }
  span {
    padding: 0 14px 0 5px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
  }
}
.study-progress {
  width: 678px;
  margin: 0 auto;
  //   position: relative;
  //   top: -150px;
  //   z-index: 1;
  padding: 36px 33px 0 33px;
  // min-height: 468px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.02);
  // margin: 0 33px;
  .progress {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 46px;
    > b {
      color: #333;
      font-weight: 400;
      font-size: 25px;
    }
    > div {
      display: flex;
      justify-content: flex-start;
      width: 525px;
      height: 18px;
      background: #eff1f3;
      border-radius: 18px;
      > span {
        display: inline-block;
        width: 0;
        height: 18px;
        background: #ff7f41;
        border-radius: 18px;
      }
    }
  }
  .study-info {
    display: flex;
    justify-content: space-between;
    padding-bottom: 50px;
    > div {
      width: 297px;
      height: 127px;
      background: #fff6ec;
      border-radius: 14px;
      position: relative;
      h3 {
        font-size: 25px;
        font-weight: 500;
        color: #333333;
        line-height: 36px;
        padding: 18px 0 14px 24px;
      }
      p {
        padding-left: 33px;
        font-size: 22px;
        font-weight: 400;
        color: #333333;
        span {
          font-size: 34px;
          font-weight: 500;
          color: #ff7f41;
          vertical-align: -2px;
          padding: 0 2px;
        }
      }
      .bgImg {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 145px;
        height: 127px;
      }
    }
  }
  .study-card {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 202px;
      margin-bottom: 50px;
      position: relative;
      text-align: center;
      h4 {
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
        padding-bottom: 20px;
      }
      p {
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        span {
          color: #ff7f41;
          font-size: 50px;
          font-weight: 500;
          padding-right: 2px;
        }
      }
    }
    > div::before {
      position: absolute;
      top: 15px;
      left: 0;
      content: '';
      width: 2px;
      height: 36px;
      background: #d8d8d8;
    }
    > div:nth-of-type(1)::before,
    > div:nth-of-type(4)::before {
      content: none;
    }
  }
}
</style>
